import type { TabKey } from '@/components/base/BaseTab.vue'

export default function useLoyaltyPageTabs() {
  const { t } = useI18n()
  const route = useRoute()

  const currentTab = ref((route?.query?.activeTab as string) || 'rewards')

  const tabs = ref<TabKey[]>([
    {
      value: 'rewards',
      name: t('pages.loyaltyPage.tabs.rewards'),
      icon: 'HeroDocumentPlusIconOutline'
    },
    {
      value: 'points',
      name: t('pages.loyaltyPage.tabs.points.title'),
      icon: 'HeroCircleStackIconOutline'
    },
    {
      value: 'settings',
      name: t('pages.loyaltyPage.tabs.settings.title'),
      icon: 'HeroCog6ToothIconOutline'
    }
  ])

  return {
    tabs,
    currentTab
  }
}
